export default function getResource(label, vars = []) {
    const resources = {
        invalidPostal: 'Enter a valid ZIP/postal code.',
        invalidBillingPostal: 'Enter a valid billing ZIP/postal code.',
        invalidPhone: 'Enter a valid phone number.',
        invalidCity: 'Enter a valid city.',
        invalidState: 'Select a valid state/province.',
        unserviceable: 'We can’t ship to this address.',
        invalidAddress: 'The address is not valid.',
        hazmatRestricted: 'This address is not eligible for hazardous items.'
    };

    return resources[label];
}
